var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingmodal",staticStyle:{"background-color":"rgba(255, 255, 255, 0.7)","backdrop-filter":"blur(4px)"}},[_c('LoadingSpinner',{staticClass:"spinner"}),_c('div',{staticClass:"loadingmodal__label"},[_vm._v(" "+_vm._s(_vm.$t('login_user.loading_user_data'))+" ")]),_c('div',{staticClass:"loadingmodal__sublabel"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }